import {Injectable} from '@angular/core';

import {ServicesService} from '../../lib/rest-service/services.service';
import {UserRestService} from '../../lib/user/services/user-rest.service';
import {HitFluencerUser} from "../../dto/HitFluencerUser";

@Injectable()
export class HitfluencerUserRestService extends UserRestService<HitFluencerUser> {

  constructor(protected services: ServicesService) {
    super();
  }


}
